module.exports = __webpack_public_path__ + "img/shield.36f7fa5a.svg";